/**
 * Lens Configurator - Multi-step prescription lens wizard
 * Requires: lens-config-data.json (loaded via fetch)
 */
(function () {
  'use strict';

  console.log('[Lens Config] Script loaded');

  const CONFIG_URL = window.__LENS_CONFIG_URL || '/assets/lens-config-data.json';
  const CART_ADD_URL = '/cart/add.js';
  const CART_URL = '/cart';

  let config = null;
  let selections = {
    prescriptionType: null,
    readingSubType: null, // 'readers' or 'prescription-reading'
    readersMagnification: null,
    distanceAndReadingSubType: null, // 'bifocal' or 'progressive'
    prescription: null,
    lensTreatment: null,
    lensTreatmentColor: null,
    lensIndex: null,
  };
  let currentStep = 0;
  let totalSteps = 5;
  let productData = {};

  // DOM refs
  const overlay = document.getElementById('lens-config-overlay');
  const stepContent = document.getElementById('lens-step-content');
  const stepTitle = document.getElementById('lens-step-title');
  const sidebarImage = document.getElementById('lens-sidebar-image');
  const sidebarTitle = document.getElementById('lens-sidebar-title');
  const sidebarPrice = document.getElementById('lens-sidebar-price');
  const btnNext = document.getElementById('lens-btn-next');
  const btnBack = document.getElementById('lens-btn-back');
  const btnClose = document.getElementById('lens-config-close-btn');
  const backBtn = document.getElementById('lens-config-back-btn');
  const progressDots = document.querySelectorAll('.lens-config-step-dot');
  const progressLines = document.querySelectorAll('.lens-config-step-line');

  // ─── Init ───────────────────────────────────────────────────────
  async function init() {
    console.log('[Lens Config] Init started');
    try {
      const res = await fetch(CONFIG_URL);
      console.log('[Lens Config] Config fetch status:', res.status);
      if (!res.ok) {
        console.error('[Lens Config] Config file not found (HTTP ' + res.status + '). Check that lens-config-data.json is in the theme assets.');
        return;
      }
      config = await res.json();
      console.log('[Lens Config] Config loaded:', config ? 'OK' : 'EMPTY');
    } catch (e) {
      console.error('[Lens Config] Failed to load config:', e.message);
      return;
    }

    // Bind trigger buttons
    var triggerBtns = document.querySelectorAll('[data-action="open-lens-configurator"]');
    console.log('[Lens Config] Found', triggerBtns.length, 'trigger buttons');
    triggerBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        console.log('[Lens Config] Button clicked');
        var title = btn.dataset.lcTitle || '';
        var productType = btn.dataset.lcProductType || '';
        productData = {
          id: btn.dataset.productId,
          variantId: btn.dataset.variantId,
          price: parseFloat(btn.dataset.lcPrice) || 0,
          title: title,
          image: btn.dataset.lcImage || '',
          isSunglasses: /sunglass/i.test(productType),
        };
        console.log('[Lens Config] productData:', productData);
        open();
      });
    });

    // Close / Back
    btnClose.addEventListener('click', close);
    backBtn.addEventListener('click', function () {
      if (currentStep > 0) {
        goToStep(currentStep - 1);
      } else {
        close();
      }
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    // Footer nav — re-query btnNext each time in case Shopify re-rendered the DOM
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#lens-btn-next');
      if (!btn) return;
      // Only handle clicks inside the lens configurator overlay
      if (!overlay || !overlay.classList.contains('is-active')) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('lens-config-btn-addtocart')) {
        addToCart();
      } else {
        goToStep(currentStep + 1);
      }
    });
    // Back button — delegate to handle DOM re-rendering
    document.addEventListener('click', function (e) {
      if (e.target.closest('#lens-btn-back')) {
        if (!overlay || !overlay.classList.contains('is-active')) return;
        e.preventDefault();
        e.stopPropagation();
        goToStep(currentStep - 1);
      }
    });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        close();
      }
    });

    // Listen for variant changes (Kalles theme uses jQuery event)
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('variant:changed', function (evt) {
        updateTriggerButtons(evt.currentVariant);
      });
    }
    // Also listen for native variant change events
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        updateTriggerButtons(e.detail.variant);
      }
    });
  }

  function updateTriggerButtons(variant) {
    if (!variant) return;
    var triggers = document.querySelectorAll('[data-action="open-lens-configurator"]');
    triggers.forEach(function (btn) {
      btn.dataset.variantId = variant.id;
      if (variant.price !== undefined) {
        btn.dataset.lcPrice = (variant.price / 100).toFixed(2);
      }
      if (variant.featured_image && variant.featured_image.src) {
        btn.dataset.lcImage = variant.featured_image.src;
      }
    });
  }

  // ─── Open / Close ───────────────────────────────────────────────
  function open() {
    console.log('[Lens Config] open() called, overlay:', overlay);
    _rxInputMode = null;
    selections = {
      prescriptionType: null,
      readingSubType: null,
      readersMagnification: null,
      distanceAndReadingSubType: null,
      prescription: null,
      lensTreatment: null,
      lensTreatmentColor: null,
      lensIndex: null,
    };
    currentStep = 0;

    sidebarImage.src = productData.image;
    sidebarImage.alt = productData.title;
    sidebarTitle.textContent = productData.title;
    updatePriceDisplay();

    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    renderStep();
  }

  function close() {
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  // ─── Step Navigation ────────────────────────────────────────────
  function getStepSequence() {
    var seq = ['prescriptionType'];

    if (selections.prescriptionType) {
      var typeId = selections.prescriptionType.id;

      if (typeId === 'distance_and_reading') {
        if (selections.distanceAndReadingSubType) {
          seq.push('prescription');
        }
      } else if (typeId === 'reading') {
        if (selections.readingSubType === 'readers') {
          seq.push('readersMagnification');
        } else if (selections.readingSubType === 'prescription-reading') {
          seq.push('prescription');
        }
      } else if (selections.prescriptionType.requires_prescription) {
        seq.push('prescription');
      }

      // Lens treatment
      seq.push('lensTreatment');

      // Skip lensIndex for non-prescription
      if (typeId !== 'non-prescription') {
        seq.push('lensIndex');
      }

      seq.push('review');
    }

    return seq;
  }

  function goToStep(step) {
    var seq = getStepSequence();
    if (step < 0 || step >= seq.length) return;

    // Validate current step before advancing
    if (step > currentStep) {
      var currentStepName = getStepSequence()[currentStep];
      if (!validateStep(currentStepName)) return;
    }

    currentStep = step;
    totalSteps = seq.length;
    renderStep();
  }

  function renderStep() {
    var seq = getStepSequence();
    var stepName = seq[currentStep];
    totalSteps = seq.length;

    // Update progress
    updateProgress();

    // Update nav buttons
    btnBack.style.visibility = currentStep > 0 ? 'visible' : 'hidden';

    if (stepName === 'review') {
      btnNext.textContent = 'ADD TO CART';
      btnNext.className = 'lens-config-btn-addtocart';
    } else {
      btnNext.textContent = 'Next →';
      btnNext.className = 'lens-config-btn-next';
    }

    // Render content
    switch (stepName) {
      case 'prescriptionType':
        renderPrescriptionTypeStep();
        break;
      case 'readingSubType':
        renderReadingSubTypeStep();
        break;
      case 'readersMagnification':
        renderReadersMagnificationStep();
        break;
      case 'prescription':
        renderPrescriptionStep();
        break;
      case 'lensTreatment':
        renderLensTreatmentStep();
        break;
      case 'lensIndex':
        renderLensIndexStep();
        break;
      case 'review':
        renderReviewStep();
        break;
    }

    updatePriceDisplay();
  }

  function updateProgress() {
    var seq = getStepSequence();
    var dotCount = Math.min(seq.length - 1, 4);

    progressDots.forEach(function (dot, i) {
      dot.classList.remove('is-active', 'is-completed');
      if (i < currentStep) {
        dot.classList.add('is-completed');
        dot.innerHTML = '✓';
      } else if (i === currentStep) {
        dot.classList.add('is-active');
        dot.textContent = i + 1;
      } else {
        dot.textContent = i + 1;
      }
    });

    progressLines.forEach(function (line, i) {
      line.classList.toggle('is-completed', i < currentStep);
    });
  }

  // ─── Validation ─────────────────────────────────────────────────
  function validateStep(stepName) {
    switch (stepName) {
      case 'prescriptionType':
        if (!selections.prescriptionType) {
          showCustomModal('Please select a prescription type.', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        if (selections.prescriptionType.id === 'reading' && !selections.readingSubType) {
          showCustomModal('Please select a reading option (Readers or Prescription Reading).', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        if (selections.prescriptionType.id === 'distance_and_reading' && !selections.distanceAndReadingSubType) {
          showCustomModal('Please select an option (Bifocal or Progressive).', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        return true;
      case 'readersMagnification':
        if (!selections.readersMagnification) {
          showCustomModal('Please select a magnification strength.', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        return true;
      case 'prescription':
        return validatePrescription();
      case 'lensTreatment':
        if (!selections.lensTreatment) {
          showCustomModal('Please select a lens treatment.', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        return true;
      case 'lensIndex':
        if (!selections.lensIndex) {
          showCustomModal('Please select a lens thickness.', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  function validatePrescription() {
    savePrescriptionValues();
    var rx = selections.prescription;

    // Upload mode: only PD is required, prescription values are in the image
    if (_rxInputMode === 'upload') {
      var hasPd = (rx && rx.pd !== null && rx.pd !== undefined) || (rx && rx.od_pd !== undefined);
      if (!hasPd) {
        showPdReminderModal();
        return false;
      }
      // Mark as having upload data so the "no input" check doesn't fire
      selections.prescription._uploaded = true;
      return true;
    }

    // Manual mode: original validation logic
    // Check if any value has been entered
    var hasAnyValue = false;
    if (rx) {
      var fields = ['od_sph', 'od_cyl', 'od_axis', 'os_sph', 'os_cyl', 'os_axis', 'pd'];
      for (var i = 0; i < fields.length; i++) {
        if (rx[fields[i]] !== null && rx[fields[i]] !== undefined) {
          hasAnyValue = true;
          break;
        }
      }
    }

    // No input at all
    if (!hasAnyValue) {
      showCustomModal(
        'You have not entered a prescription for your glasses. Would you like for us to process your order with Non-Prescription lenses?',
        [
          {
            label: 'Confirm', className: 'lens-modal-btn-confirm',
            action: function () {
              hideCustomModal();
              // Switch to non-prescription flow
              var nonRxType = config.lens_configurator.prescription_types.find(function (t) { return t.id === 'non-prescription'; });
              selections.prescriptionType = nonRxType;
              selections.readingSubType = null;
              selections.readersMagnification = null;
              selections.distanceAndReadingSubType = null;
              selections.prescription = null;
              currentStep = 0;
              _rxInputMode = null;
              renderStep();
            }
          },
          {
            label: 'Cancel', className: 'lens-modal-btn-cancel',
            action: function () { hideCustomModal(); }
          }
        ]
      );
      return false;
    }

    var hasSph = (rx.od_sph !== null && rx.od_sph !== undefined) || (rx.os_sph !== null && rx.os_sph !== undefined);
    var hasCyl = (rx.od_cyl !== null && rx.od_cyl !== undefined) || (rx.os_cyl !== null && rx.os_cyl !== undefined);
    var hasAxis = (rx.od_axis !== null && rx.od_axis !== undefined) || (rx.os_axis !== null && rx.os_axis !== undefined);
    var hasPd = (rx.pd !== null && rx.pd !== undefined) || (rx.od_pd !== undefined);

    // SPH entered but no PD
    if (hasSph && !hasCyl && !hasPd) {
      showPdReminderModal();
      return false;
    }

    // CYL entered but no AXIS
    if (hasCyl && !hasAxis) {
      showCustomModal(
        'Alert: You chose CYL value, please add the Axis value.',
        [{ label: 'Got it. Thanks.', action: function () { hideCustomModal(); } }]
      );
      return false;
    }

    // SPH, CYL, AXIS entered but no PD
    if (hasSph && hasCyl && hasAxis && !hasPd) {
      showPdReminderModal();
      return false;
    }

    // SPH entered, no PD (general case)
    if (hasSph && !hasPd) {
      showPdReminderModal();
      return false;
    }

    return true;
  }

  function showPdReminderModal() {
    showCustomModal(
      'Please select your pupillary distance (PD).' +
      '<br><br>Pupillary distance or PD is the distance from the center of the pupil in one eye to the center of the pupil in the other eye.' +
      '<br><br>If you do not have the PD, you can measure it as shown below:' +
      '<br><br><img src="/assets/pd-measure-guide.jpg" alt="How to measure PD" style="max-width:100%;border-radius:8px;margin-top:8px;">',
      [{ label: 'Got it. Thanks.', action: function () { hideCustomModal(); } }]
    );
  }

  // ─── Custom Modal ───────────────────────────────────────────────
  // Store button actions globally so onclick can access them
  var _modalButtonActions = [];

  function showCustomModal(message, buttons) {
    var existing = document.getElementById('lens-custom-modal');
    if (existing) existing.remove();

    _modalButtonActions = buttons.map(function (b) { return b.action; });

    var modal = document.createElement('div');
    modal.id = 'lens-custom-modal';
    modal.className = 'lens-custom-modal-overlay';

    var btnsHtml = '';
    buttons.forEach(function (btn, i) {
      btnsHtml += '<button type="button" class="lens-custom-modal-btn ' + (btn.className || '') + '" onclick="window._lensModalBtnClick(' + i + ')">' + escapeHtml(btn.label) + '</button>';
    });

    modal.innerHTML =
      '<div class="lens-custom-modal">' +
        '<div class="lens-custom-modal-body">' + message + '</div>' +
        '<div class="lens-custom-modal-footer">' + btnsHtml + '</div>' +
      '</div>';

    // Expose click handler globally
    window._lensModalBtnClick = function (idx) {
      if (_modalButtonActions[idx]) {
        _modalButtonActions[idx]();
      }
    };

    document.body.appendChild(modal);

    // Also close on overlay background click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        hideCustomModal();
      }
    });

    // Show with animation
    requestAnimationFrame(function () {
      modal.classList.add('is-active');
    });
  }

  function hideCustomModal() {
    var modal = document.getElementById('lens-custom-modal');
    if (modal) {
      modal.classList.remove('is-active');
      setTimeout(function () {
        if (modal.parentNode) modal.remove();
      }, 300);
    }
  }

  // ─── Price Calculation ──────────────────────────────────────────
  function calculateLensServicePrice() {
    var treatmentPrice = selections.lensTreatment ? selections.lensTreatment.price || 0 : 0;
    var indexPrice = selections.lensIndex ? selections.lensIndex.price || 0 : 0;
    var prescriptionUpcharge = 0;
    var prismPrice = 0;

    if (selections.prescriptionType) {
      if (productData.isSunglasses && selections.prescriptionType.sunglasses_price !== undefined) {
        prescriptionUpcharge = selections.prescriptionType.sunglasses_price || 0;
      } else {
        prescriptionUpcharge = selections.prescriptionType.price_upcharge || 0;
      }

      // Distance & Reading: use sub-option price instead of base upcharge
      if (selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType) {
        var subOpts = config.lens_configurator.distance_and_reading_sub_options;
        var subOpt = subOpts.find(function (s) { return s.id === selections.distanceAndReadingSubType; });
        if (subOpt) {
          prescriptionUpcharge = productData.isSunglasses ? subOpt.sunglasses_price : subOpt.price;
        }
      }
    }

    // Prism surcharge
    if (selections.prescription && selections.prescription.has_prism) {
      prismPrice = (config.lens_configurator.prescription_fields.prism_price) || 19;
    }

    return treatmentPrice + indexPrice + prescriptionUpcharge + prismPrice;
  }

  function calculateTotalPrice() {
    return (productData.price + calculateLensServicePrice()) * getSelectedQuantity();
  }

  function updatePriceDisplay() {
    var total = calculateTotalPrice();
    sidebarPrice.textContent = '$' + total.toFixed(2);
  }

  // ─── Step Renderers ─────────────────────────────────────────────

  // STEP 1: Prescription Type
  function renderPrescriptionTypeStep() {
    stepTitle.innerHTML =
      '<h3>Choose Lens Type</h3>' +
      '<p>Select the type of lenses you need</p>';

    var types = config.lens_configurator.prescription_types;
    var html = '<div class="lens-option-grid">';

    types.forEach(function (type) {
      var isSelected = selections.prescriptionType && selections.prescriptionType.id === type.id;
      var priceLabel = '';
      if (type.id === 'distance_and_reading') {
        // Show sub-option prices
        var subOpts = config.lens_configurator.distance_and_reading_sub_options;
        if (subOpts && subOpts.length > 0) {
          var minPrice = productData.isSunglasses ? subOpts[0].sunglasses_price : subOpts[0].price;
          subOpts.forEach(function (s) {
            var p = productData.isSunglasses ? s.sunglasses_price : s.price;
            if (p < minPrice) minPrice = p;
          });
          priceLabel = minPrice > 0 ? '+$' + minPrice.toFixed(2) + '+' : '';
        }
      } else {
        var upcharge = productData.isSunglasses && type.sunglasses_price !== undefined ? type.sunglasses_price : type.price_upcharge;
        priceLabel = upcharge > 0 ? '+$' + upcharge.toFixed(2) : '';
      }

      var isExpandedDr = type.id === 'distance_and_reading' && (isSelected || (selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading'));
      var isExpandedReading = type.id === 'reading' && (isSelected || (selections.prescriptionType && selections.prescriptionType.id === 'reading'));

      html +=
        '<div class="lens-option-card' + (isSelected ? ' is-selected' : '') + '" data-type-id="' + type.id + '">' +
          '<div class="lens-option-icon">' + getTypeIcon(type.id) + '</div>' +
          '<div class="lens-option-info">' +
            '<div class="lens-option-title">' + escapeHtml(type.name) + '</div>' +
            '<div class="lens-option-subtitle">' + escapeHtml(type.subtitle) + '</div>' +
            '<div class="lens-option-description">' + escapeHtml(type.description) + '</div>' +
          '</div>' +
          (priceLabel ? '<div class="lens-option-price">' + priceLabel + '</div>' : '') +
        '</div>';

      // Inline sub-options for Distance & Reading
      if (type.id === 'distance_and_reading' && isExpandedDr) {
        var subOpts = config.lens_configurator.distance_and_reading_sub_options;
        html += '<div class="lens-reading-sub-options">';
        subOpts.forEach(function (sub) {
          var subSelected = selections.distanceAndReadingSubType === sub.id;
          var subPrice = productData.isSunglasses ? sub.sunglasses_price : sub.price;
          html +=
            '<div class="lens-reading-sub-card' + (subSelected ? ' is-selected' : '') + '" data-dr-sub-type="' + sub.id + '">' +
              '<div class="lens-reading-sub-title">' + escapeHtml(sub.name) + '</div>' +
              '<div class="lens-reading-sub-desc">+$' + subPrice.toFixed(2) + '</div>' +
            '</div>';
        });
        html += '</div>';
      }

      // Inline sub-options for Reading
      if (type.id === 'reading' && isExpandedReading) {
        var subReaders = selections.readingSubType === 'readers';
        var subPrescription = selections.readingSubType === 'prescription-reading';
        html +=
          '<div class="lens-reading-sub-options">' +
            '<div class="lens-reading-sub-card' + (subReaders ? ' is-selected' : '') + '" data-sub-type="readers">' +
              '<div class="lens-reading-sub-title">Readers</div>' +
              '<div class="lens-reading-sub-desc">Select a magnification strength</div>' +
            '</div>' +
            '<div class="lens-reading-sub-card' + (subPrescription ? ' is-selected' : '') + '" data-sub-type="prescription-reading">' +
              '<div class="lens-reading-sub-title">Prescription Reading</div>' +
              '<div class="lens-reading-sub-desc">Offer magnification by adding your prescription</div>' +
            '</div>' +
          '</div>';
      }
    });

    html += '</div>';
    stepContent.innerHTML = html;

    // Bind type card clicks
    stepContent.querySelectorAll('.lens-option-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var typeId = card.dataset.typeId;
        var type = types.find(function (t) { return t.id === typeId; });
        selections.prescriptionType = type;

        // Reset sub-selections when changing type
        if (type.id !== 'reading') {
          selections.readingSubType = null;
          selections.readersMagnification = null;
        }
        if (type.id !== 'distance_and_reading') {
          selections.distanceAndReadingSubType = null;
        }
        if (!type.requires_prescription) {
          selections.prescription = null;
        }

        // Re-render to show/hide sub-options
        renderPrescriptionTypeStep();
        updatePriceDisplay();
      });
    });

    // Bind sub-option card clicks for Reading
    stepContent.querySelectorAll('.lens-reading-sub-card[data-sub-type]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
        var subType = card.dataset.subType;
        selections.readingSubType = subType;

        stepContent.querySelectorAll('.lens-reading-sub-card[data-sub-type]').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        updatePriceDisplay();
      });
    });

    // Bind sub-option card clicks for Distance & Reading
    stepContent.querySelectorAll('.lens-reading-sub-card[data-dr-sub-type]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
        var subType = card.dataset.drSubType;
        selections.distanceAndReadingSubType = subType;

        stepContent.querySelectorAll('.lens-reading-sub-card[data-dr-sub-type]').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        updatePriceDisplay();
      });
    });
  }

  // Readers Magnification Step
  function renderReadersMagnificationStep() {
    stepTitle.innerHTML =
      '<h3>Select a Magnification Strength</h3>' +
      '<p>Choose the reading power that works best for you</p>';

    var html = '<div class="lens-magnification-grid">';
    var strengths = [];
    for (var val = 0.25; val <= 6.00; val += 0.25) {
      strengths.push(parseFloat(val.toFixed(2)));
    }

    strengths.forEach(function (s) {
      var isSelected = selections.readersMagnification === s;
      var label = '+' + s.toFixed(2);
      html += '<div class="lens-magnification-item' + (isSelected ? ' is-selected' : '') + '" data-value="' + s + '">' + label + '</div>';
    });

    html += '</div>';
    stepContent.innerHTML = html;

    // Bind clicks
    stepContent.querySelectorAll('.lens-magnification-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var value = parseFloat(item.dataset.value);
        selections.readersMagnification = value;

        stepContent.querySelectorAll('.lens-magnification-item').forEach(function (i) {
          i.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
      });
    });
  }

  // STEP 2: Prescription Input — choice screen, then upload or manual form
  var _rxInputMode = null; // null = not chosen, 'upload', 'manual'

  function renderPrescriptionStep() {
    if (_rxInputMode === 'upload') {
      renderRxUploadStep();
      return;
    }
    if (_rxInputMode === 'manual') {
      renderRxManualStep();
      return;
    }
    // Default: show choice screen (upload vs manual)
    renderRxChoiceStep();
  }

  function renderRxChoiceStep() {
    stepTitle.innerHTML =
      '<h3>How would you like to provide your prescription?</h3>' +
      '<p>Upload a photo or enter your details manually</p>';

    var html =
      '<div class="lens-rx-choice-grid">' +
        '<div class="lens-rx-choice-card" id="lens-rx-choice-upload">' +
          '<div class="lens-rx-choice-icon">' +
            '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#B37A4C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>' +
          '</div>' +
          '<div class="lens-rx-choice-info">' +
            '<div class="lens-rx-choice-title">Upload Prescription Image</div>' +
            '<div class="lens-rx-choice-desc">Take a photo of your prescription and upload it. We\'ll process it for you.</div>' +
          '</div>' +
        '</div>' +
        '<div class="lens-rx-choice-card" id="lens-rx-choice-manual">' +
          '<div class="lens-rx-choice-icon">' +
            '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#B37A4C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="7" y1="16" x2="13" y2="16"/></svg>' +
          '</div>' +
          '<div class="lens-rx-choice-info">' +
            '<div class="lens-rx-choice-title">Enter Manually</div>' +
            '<div class="lens-rx-choice-desc">Type in your SPH, CYL, AXIS and other values directly.</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    stepContent.innerHTML = html;

    // Bind choice card clicks
    document.getElementById('lens-rx-choice-upload').addEventListener('click', function () {
      _rxInputMode = 'upload';
      renderStep();
    });
    document.getElementById('lens-rx-choice-manual').addEventListener('click', function () {
      _rxInputMode = 'manual';
      renderStep();
    });
  }

  // --- Upload path: image + PD + Prism ---
  function renderRxUploadStep() {
    stepTitle.innerHTML =
      '<h3>Upload Your Prescription</h3>' +
      '<p>Upload a photo, then enter your PD below</p>' +
      '<div class="lens-upload-banner" id="lens-switch-to-manual">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="7" y1="16" x2="13" y2="16"/></svg>' +
        '<span>Or <strong>fill it out manually</strong> instead</span>' +
      '</div>';

    var fields = config.lens_configurator.prescription_fields;
    var rx = selections.prescription || {};

    var html = '<div class="lens-rx-form">';

    // Upload area
    html += '<div class="lens-upload-area" id="lens-upload-area">' +
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#B37A4C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>' +
      '<div class="lens-upload-area-text">Click to upload prescription image</div>' +
      '<div class="lens-upload-area-hint">JPG, PNG accepted</div>' +
      '<div class="lens-upload-area-filename" id="lens-upload-filename"></div>' +
    '</div>';

    // PD section
    html += '<div class="lens-rx-pd" style="margin-top:16px;">' +
      '<label>PD (Pupillary Distance) <span style="color:#e74c3c;">*</span></label>';

    if (fields.supports_two_pd) {
      html += '<label class="lens-rx-pd-checkbox">' +
        '<input type="checkbox" id="lens-dual-pd" ' + (rx.od_pd !== undefined ? 'checked' : '') + '> ' +
        'Dual PD (separate for each eye)' +
        '</label>';
    }

    html += '</div>';

    html += '<div id="lens-pd-fields" style="margin-top:8px;">';
    if (rx.od_pd !== undefined) {
      html += '<div style="display:flex;gap:16px;align-items:center;">' +
        '<div><label style="font-size:13px;color:#666;">OD (Right)</label>' +
        buildDropdown('od_pd', rx.od_pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true) +
        '</div>' +
        '<div><label style="font-size:13px;color:#666;">OS (Left)</label>' +
        buildDropdown('os_pd', rx.os_pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true) +
        '</div>' +
        '</div>';
    } else {
      html += buildDropdown('pd', rx.pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true);
    }
    html += '</div>';

    // Prism (optional)
    if (fields.prism_available) {
      html += '<div class="lens-prism-section">' +
        '<label class="lens-prism-toggle">' +
          '<input type="checkbox" id="lens-prism-toggle" ' + (rx.has_prism ? 'checked' : '') + '> ' +
          'Add Prism (+$' + fields.prism_price.toFixed(2) + ')' +
        '</label>' +
        '<div class="lens-prism-fields" id="lens-prism-fields" style="' + (rx.has_prism ? 'display:grid;' : 'display:none;') + '">' +
          buildPrismFields(rx) +
        '</div>' +
        '</div>';
    }

    html += '</div>';
    stepContent.innerHTML = html;

    // Bind upload area click
    var uploadArea = document.getElementById('lens-upload-area');
    if (uploadArea) {
      uploadArea.addEventListener('click', function () {
        var fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.addEventListener('change', function (e) {
          var file = e.target.files[0];
          if (file) {
            selections.prescription = selections.prescription || {};
            selections.prescription._uploadedFileName = file.name;
            selections.prescription._uploadedMimeType = file.type || 'image/jpeg';
            // Convert to base64 immediately so it survives step navigation
            // (File object is lost when the dynamically-created input is removed)
            var reader = new FileReader();
            reader.onload = function () {
              selections.prescription._uploadedBase64 = reader.result.split(',')[1];
              console.log('[Lens Config] File converted to base64:', file.name, '(' + selections.prescription._uploadedBase64.length + ' chars)');
            };
            reader.readAsDataURL(file);
            var fnEl = document.getElementById('lens-upload-filename');
            if (fnEl) fnEl.textContent = '✓ ' + file.name;
            uploadArea.classList.add('has-file');
          }
        });
        fileInput.click();
      });
    }

    // Back to manual entry link
    var backToManual = document.getElementById('lens-switch-to-manual');
    if (backToManual) {
      backToManual.addEventListener('click', function () {
        _rxInputMode = 'manual';
        renderStep();
      });
    }

    bindDropdowns();

    // Dual PD toggle
    var dualPdCheckbox = document.getElementById('lens-dual-pd');
    if (dualPdCheckbox) {
      dualPdCheckbox.addEventListener('change', function () {
        savePrescriptionValues();
        if (dualPdCheckbox.checked) {
          selections.prescription.od_pd = selections.prescription.pd || null;
          selections.prescription.os_pd = selections.prescription.pd || null;
          delete selections.prescription.pd;
        } else {
          selections.prescription.pd = selections.prescription.od_pd || null;
          delete selections.prescription.od_pd;
          delete selections.prescription.os_pd;
        }
        renderRxUploadStep();
      });
    }

    // Prism toggle
    var prismToggle = document.getElementById('lens-prism-toggle');
    if (prismToggle) {
      prismToggle.addEventListener('change', function () {
        var fieldsEl = document.getElementById('lens-prism-fields');
        fieldsEl.style.display = prismToggle.checked ? 'grid' : 'none';
        selections.prescription = selections.prescription || {};
        selections.prescription.has_prism = prismToggle.checked;
      });
    }
  }

  // --- Manual entry path (original prescription form) ---
  function renderRxManualStep() {
    var fields = config.lens_configurator.prescription_fields;
    stepTitle.innerHTML =
      '<h3>Enter Your Prescription</h3>' +
      '<p>Fill in your prescription details below</p>' +
      '<div class="lens-upload-banner" id="lens-switch-to-upload">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>' +
        '<span>Or <strong>upload a photo</strong> of your prescription instead</span>' +
      '</div>';

    var rx = selections.prescription || {
      od_sph: null, od_cyl: null, od_axis: null,
      os_sph: null, os_cyl: null, os_axis: null,
      od_add: null, os_add: null, pd: null,
    };
    var needsAdd = selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType;

    var html = '<div class="lens-rx-form">';

    // OD / OS Table
    html += '<table class="lens-rx-table"><thead><tr>' +
      '<th></th><th>SPH</th><th>CYL</th><th>AXIS</th>' +
      (needsAdd ? '<th>ADD</th>' : '') +
      '</tr></thead><tbody>';
    html += buildRxRow('OD', 'Right Eye', rx, 'od', fields, needsAdd);
    html += buildRxRow('OS', 'Left Eye', rx, 'os', fields, needsAdd);
    html += '</tbody></table>';

    // PD
    html += '<div class="lens-rx-pd">' +
      '<label>PD (Pupillary Distance)</label>';

    if (fields.supports_two_pd) {
      html += '<label class="lens-rx-pd-checkbox">' +
        '<input type="checkbox" id="lens-dual-pd" ' + (rx.od_pd !== undefined ? 'checked' : '') + '> ' +
        'Dual PD (separate for each eye)' +
        '</label>';
    }

    html += '</div>';

    html += '<div id="lens-pd-fields" style="margin-top:8px;">';
    if (rx.od_pd !== undefined) {
      html += '<div style="display:flex;gap:16px;align-items:center;">' +
        '<div><label style="font-size:13px;color:#666;">OD (Right)</label>' +
        buildDropdown('od_pd', rx.od_pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true) +
        '</div>' +
        '<div><label style="font-size:13px;color:#666;">OS (Left)</label>' +
        buildDropdown('os_pd', rx.os_pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true) +
        '</div>' +
        '</div>';
    } else {
      html += buildDropdown('pd', rx.pd, fields.pd_range.min, fields.pd_range.max, fields.pd_range.step, 'Select PD', true);
    }
    html += '</div>';

    // Prism (optional)
    if (fields.prism_available) {
      html += '<div class="lens-prism-section">' +
        '<label class="lens-prism-toggle">' +
          '<input type="checkbox" id="lens-prism-toggle"> ' +
          'Add Prism (+$' + fields.prism_price.toFixed(2) + ')' +
        '</label>' +
        '<div class="lens-prism-fields" id="lens-prism-fields" style="display:none;">' +
          buildPrismFields(rx) +
        '</div>' +
        '</div>';
    }

    html += '</div>';
    stepContent.innerHTML = html;

    // Bind dropdowns
    bindDropdowns();

    // Upload banner click → switch to upload mode
    var uploadBanner = document.getElementById('lens-switch-to-upload');
    if (uploadBanner) {
      uploadBanner.addEventListener('click', function () {
        _rxInputMode = 'upload';
        renderStep();
      });
    }

    // Dual PD toggle
    var dualPdCheckbox = document.getElementById('lens-dual-pd');
    if (dualPdCheckbox) {
      dualPdCheckbox.addEventListener('change', function () {
        savePrescriptionValues();
        if (dualPdCheckbox.checked) {
          selections.prescription.od_pd = selections.prescription.pd || null;
          selections.prescription.os_pd = selections.prescription.pd || null;
          delete selections.prescription.pd;
        } else {
          selections.prescription.pd = selections.prescription.od_pd || null;
          delete selections.prescription.od_pd;
          delete selections.prescription.os_pd;
        }
        renderPrescriptionStep();
      });
    }

    // Prism toggle
    var prismToggle = document.getElementById('lens-prism-toggle');
    if (prismToggle) {
      prismToggle.addEventListener('change', function () {
        var fieldsEl = document.getElementById('lens-prism-fields');
        fieldsEl.style.display = prismToggle.checked ? 'grid' : 'none';
        selections.prescription = selections.prescription || {};
        selections.prescription.has_prism = prismToggle.checked;
      });
    }
  }

  function buildRxRow(label, eyeLabel, rx, prefix, fields, needsAdd) {
    var row = '<tr>' +
      '<td>' + label + '<br><small style="color:#999;font-weight:400;">' + eyeLabel + '</small></td>' +
      '<td>' + buildDropdown(prefix + '_sph', rx[prefix + '_sph'], fields.sph_range.min, fields.sph_range.max, fields.sph_range.step, 'Select SPH') + '</td>' +
      '<td>' + buildDropdown(prefix + '_cyl', rx[prefix + '_cyl'], fields.cyl_range.min, fields.cyl_range.max, fields.cyl_range.step, 'Select CYL') + '</td>' +
      '<td>' + buildAxisInput(prefix + '_axis', rx[prefix + '_axis']) + '</td>';
    if (needsAdd) {
      row += '<td>' + buildDropdown(prefix + '_add', rx[prefix + '_add'], fields.add_range.min, fields.add_range.max, fields.add_range.step, 'Select ADD') + '</td>';
    }
    row += '</tr>';
    return row;
  }

  function buildDropdown(name, value, min, max, step, placeholder, integerMode) {
    var selectedDisplay;
    if (integerMode) {
      selectedDisplay = value !== null && value !== undefined ? Math.round(value).toString() : '';
    } else {
      selectedDisplay = value !== null && value !== undefined ? formatRxValue(value) : '';
    }
    var html = '<select class="lens-rx-select" name="' + name + '" aria-label="' + name + '">' +
      '<option value="">' + escapeHtml(placeholder) + '</option>';

    for (var val = min; val <= max; val += step) {
      var v = parseFloat(val.toFixed(2));
      var label;
      if (integerMode) {
        label = Math.round(v).toString();
      } else {
        label = (v > 0 ? '+' : '') + v.toFixed(2);
      }
      var selected = (value !== null && value !== undefined && Math.abs(value - v) < 0.001) ? ' selected' : '';
      html += '<option value="' + v + '"' + selected + '>' + label + '</option>';
    }

    html += '</select>';
    return html;
  }

  function buildAxisInput(name, value) {
    var displayVal = value !== null && value !== undefined ? value : '';
    return '<input type="number" class="lens-rx-axis-input" name="' + name + '" ' +
      'value="' + displayVal + '" min="1" max="180" step="1" placeholder="Axis" aria-label="' + name + '">';
  }

  function buildPrismFields(rx) {
    var html = '';
    var eyes = [
      { prefix: 'od', label: 'OD (Right)' },
      { prefix: 'os', label: 'OS (Left)' },
    ];
    var directions = ['Up', 'Down', 'In', 'Out'];

    eyes.forEach(function (eye) {
      html += '<div class="lens-prism-field">' +
        '<label>' + eye.label + ' - Prism Amount</label>' +
        '<select name="' + eye.prefix + '_prism_amount">' +
        '<option value="">Select</option>';
      for (var i = 0.5; i <= 5; i += 0.5) {
        var sel = rx[eye.prefix + '_prism_amount'] === i ? ' selected' : '';
        html += '<option value="' + i + '"' + sel + '>' + i.toFixed(1) + '</option>';
      }
      html += '</select></div>';

      html += '<div class="lens-prism-field">' +
        '<label>' + eye.label + ' - Direction</label>' +
        '<select name="' + eye.prefix + '_prism_direction">' +
        '<option value="">Select</option>';
      directions.forEach(function (d) {
        var sel = rx[eye.prefix + '_prism_direction'] === d ? ' selected' : '';
        html += '<option value="' + d + '"' + sel + '>' + d + '</option>';
      });
      html += '</select></div>';
    });

    return html;
  }

  function bindDropdowns() {
    stepContent.querySelectorAll('.lens-rx-select, .lens-rx-axis-input').forEach(function (el) {
      el.addEventListener('change', function () {
        savePrescriptionValues();
      });
    });
  }

  function savePrescriptionValues() {
    if (!selections.prescription) {
      selections.prescription = {};
    }
    var rx = selections.prescription;

    // Save dropdowns
    stepContent.querySelectorAll('.lens-rx-select').forEach(function (sel) {
      if (sel.value !== '') {
        rx[sel.name] = parseFloat(sel.value);
      } else {
        rx[sel.name] = null;
      }
    });

    // Save axis inputs
    stepContent.querySelectorAll('.lens-rx-axis-input').forEach(function (input) {
      var val = parseInt(input.value);
      if (!isNaN(val) && val >= 1 && val <= 180) {
        rx[input.name] = val;
      } else if (input.value === '') {
        rx[input.name] = null;
      }
    });

    // Save prism selects
    stepContent.querySelectorAll('.lens-prism-field select').forEach(function (sel) {
      if (sel.value) {
        rx[sel.name] = parseFloat(sel.value) || sel.value;
      }
    });
  }

  // Prescription Confirmation Modal
  function showPrescriptionConfirmModal(callback) {
    var rx = selections.prescription;
    var typeName = selections.prescriptionType ? selections.prescriptionType.name : 'Distance';
    if (selections.readingSubType === 'readers') {
      typeName = 'Readers';
    } else if (selections.readingSubType === 'prescription-reading') {
      typeName = 'Prescription Reading';
    } else if (selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading') {
      var subOpt = config.lens_configurator.distance_and_reading_sub_options.find(function (s) { return s.id === selections.distanceAndReadingSubType; });
      typeName = subOpt ? subOpt.name : 'Distance & Reading';
    }

    var pdDisplay = '';
    if (rx.od_pd !== undefined) {
      pdDisplay = rx.od_pd + '/' + rx.os_pd;
    } else if (rx.pd !== null && rx.pd !== undefined) {
      pdDisplay = rx.pd.toString();
    }

    var html;

    if (_rxInputMode === 'upload' && rx._uploadedFileName) {
      // Upload mode — simple confirmation
      html =
        '<div class="lens-rx-confirm">' +
          '<h4 style="margin:0 0 12px;font-size:18px;font-weight:700;color:#2E2C2A;">Confirm your details</h4>' +
          '<div style="margin-bottom:8px;font-size:14px;color:#555;">' +
            '<strong>Prescription Type:</strong> ' + escapeHtml(typeName) +
          '</div>' +
          '<div style="margin-bottom:8px;font-size:14px;color:#555;">' +
            '<strong>Prescription Image:</strong> ' + escapeHtml(rx._uploadedFileName) +
          '</div>' +
          '<div style="margin-bottom:8px;font-size:14px;color:#555;">' +
            '<strong>PD:</strong> ' + pdDisplay +
          '</div>' +
        '</div>';
    } else {
      // Manual mode — full prescription table
      var needsAdd = selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType;
      html =
        '<div class="lens-rx-confirm">' +
          '<h4 style="margin:0 0 12px;font-size:18px;font-weight:700;color:#2E2C2A;">Does this match your prescription?</h4>' +
          '<div style="margin-bottom:12px;font-size:14px;color:#555;">' +
            '<strong>Prescription Type:</strong> ' + escapeHtml(typeName) +
          '</div>' +
          '<table class="lens-rx-confirm-table">' +
            '<thead><tr><th></th><th>SPH</th><th>CYL</th><th>AXIS</th>' +
            (needsAdd ? '<th>ADD</th>' : '') +
            '<th>PD</th></tr></thead>' +
            '<tbody>' +
              '<tr><td>OD</td>' +
                '<td>' + formatRxValue(rx.od_sph) + '</td>' +
                '<td>' + formatRxValue(rx.od_cyl) + '</td>' +
                '<td>' + (rx.od_axis !== null && rx.od_axis !== undefined ? rx.od_axis : '-') + '</td>' +
                (needsAdd ? '<td>' + formatRxValue(rx.od_add) + '</td>' : '') +
                '<td rowspan="2">' + pdDisplay + '</td>' +
              '</tr>' +
              '<tr><td>OS</td>' +
                '<td>' + formatRxValue(rx.os_sph) + '</td>' +
                '<td>' + formatRxValue(rx.os_cyl) + '</td>' +
                '<td>' + (rx.os_axis !== null && rx.os_axis !== undefined ? rx.os_axis : '-') + '</td>' +
                (needsAdd ? '<td>' + formatRxValue(rx.os_add) + '</td>' : '') +
              '</tr>' +
            '</tbody>' +
          '</table>' +
        '</div>';
    }

    showCustomModal(html, [
      {
        label: 'CONFIRM', className: 'lens-modal-btn-confirm',
        action: function () { hideCustomModal(); callback(true); }
      },
      {
        label: 'EDIT', className: 'lens-modal-btn-cancel',
        action: function () { hideCustomModal(); callback(false); }
      }
    ]);
  }

  // Override goToStep for prescription confirmation
  var originalGoToStep = goToStep;
  goToStep = function (step) {
    var seq = getStepSequence();
    if (step > currentStep) {
      var currentStepName = seq[currentStep];
      // If we're on prescription step and moving forward, show confirmation
      if (currentStepName === 'prescription') {
        savePrescriptionValues();
        if (!validatePrescription()) return;
        showPrescriptionConfirmModal(function (confirmed) {
          if (confirmed) {
            currentStep = step;
            totalSteps = seq.length;
            renderStep();
          }
        });
        return;
      }
      // If we're on reading magnification step and it's a "readers" flow, store the magnification as prescription
      if (currentStepName === 'readersMagnification' && selections.readingSubType === 'readers') {
        if (!selections.readersMagnification) {
          showCustomModal('Please select a magnification strength.', [{ label: 'OK', action: function () { hideCustomModal(); } }]);
          return;
        }
        // Store readers magnification as the prescription
        selections.prescription = {
          od_sph: selections.readersMagnification,
          od_cyl: null,
          od_axis: null,
          os_sph: selections.readersMagnification,
          os_cyl: null,
          os_axis: null,
          od_add: null,
          os_add: null,
          pd: null,
        };
      }
    }
    originalGoToStep(step);
  };

  // STEP 3: Lens Treatment
  function renderLensTreatmentStep() {
    stepTitle.innerHTML =
      '<h3>Choose Lens Treatment</h3>' +
      '<p>Select your preferred lens coating and treatment</p>';

    var treatments = productData.isSunglasses
      ? config.lens_configurator.sunglasses_lens_types
      : config.lens_configurator.lens_types;
    var html = '<div class="lens-option-grid">';

    treatments.forEach(function (treatment) {
      var isSelected = selections.lensTreatment && selections.lensTreatment.id === treatment.id;
      var priceLabel = treatment.price > 0 ? '+$' + treatment.price.toFixed(2) : 'Free';

      html +=
        '<div class="lens-option-card' + (isSelected ? ' is-selected' : '') + '" data-treatment-id="' + treatment.id + '">' +
          '<div class="lens-option-icon">' + getTreatmentIcon(treatment.id) + '</div>' +
          '<div class="lens-option-info">' +
            '<div class="lens-option-title">' + escapeHtml(treatment.name) + '</div>' +
            '<div class="lens-option-description">' + escapeHtml(treatment.description) + '</div>' +
            (treatment.badge ? '<span class="lens-option-badge">' + escapeHtml(treatment.badge) + '</span>' : '') +
          '</div>' +
          '<div class="lens-option-price">' + priceLabel + '</div>' +
        '</div>';

      // Color picker for tinted/polarized
      if (treatment.color_options && isSelected) {
        html += '<div class="lens-color-picker" data-treatment="' + treatment.id + '">';
        treatment.color_options.forEach(function (color) {
          var isColorSelected = selections.lensTreatmentColor === color;
          html += '<div class="lens-color-swatch' + (isColorSelected ? ' is-selected' : '') + '" ' +
            'data-color="' + color + '" ' +
            'style="background:' + getColorHex(color) + ';" ' +
            'title="' + capitalize(color) + '"></div>';
        });
        html += '</div>';
      }
    });

    html += '</div>';
    stepContent.innerHTML = html;

    // Bind treatment clicks
    stepContent.querySelectorAll('.lens-option-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var treatmentId = card.dataset.treatmentId;
        var treatment = treatments.find(function (t) { return t.id === treatmentId; });
        selections.lensTreatment = treatment;
        selections.lensTreatmentColor = null;

        renderLensTreatmentStep();
        updatePriceDisplay();
      });
    });

    // Bind color swatches
    stepContent.querySelectorAll('.lens-color-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.stopPropagation();
        selections.lensTreatmentColor = swatch.dataset.color;
        stepContent.querySelectorAll('.lens-color-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
      });
    });
  }

  // STEP 4: Lens Index/Thickness
  function renderLensIndexStep() {
    stepTitle.innerHTML =
      '<h3>Choose Lens Thickness</h3>' +
      '<p>Higher index = thinner lens. Recommended for stronger prescriptions.</p>' +
      '<div class="lens-info-banner">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F9A825" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
        'All our lenses include scratch-resistant, anti-reflective and hard coatings.' +
      '</div>';

    var indexes = config.lens_configurator.lens_indexes;
    var html = '<div class="lens-option-grid">';

    indexes.forEach(function (idx) {
      var isSelected = selections.lensIndex && selections.lensIndex.id === idx.id;
      var priceLabel = idx.price > 0 ? '+$' + idx.price.toFixed(2) : 'Free';

      html +=
        '<div class="lens-option-card' + (isSelected ? ' is-selected' : '') + '" data-index-id="' + idx.id + '">' +
          '<div class="lens-option-icon">' + getIndexIcon(idx.id) + '</div>' +
          '<div class="lens-option-info">' +
            '<div class="lens-option-title">' + escapeHtml(idx.name) +
              (idx.recommended ? ' <span class="lens-option-recommended">Recommended</span>' : '') +
            '</div>' +
            '<div class="lens-option-description">' + escapeHtml(idx.description) + '</div>' +
          '</div>' +
          '<div class="lens-option-price">' + priceLabel + '</div>' +
        '</div>';
    });

    html += '</div>';
    stepContent.innerHTML = html;

    stepContent.querySelectorAll('.lens-option-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var indexId = card.dataset.indexId;
        var idx = indexes.find(function (i) { return i.id === indexId; });
        selections.lensIndex = idx;

        stepContent.querySelectorAll('.lens-option-card').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');

        setTimeout(function () { goToStep(currentStep + 1); }, 300);
      });
    });
  }

  // STEP 5: Review
  function renderReviewStep() {
    stepTitle.innerHTML =
      '<h3>Review Your Selections</h3>' +
      '<p>Please confirm your choices before adding to cart</p>';

    var lensServicePrice = calculateLensServicePrice();
    var orderQty = getSelectedQuantity();
    var totalPrice = calculateTotalPrice();
    var needsAdd = selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType;

    var html = '<div class="lens-review">';

    // Frame info
    html += '<div class="lens-review-section">' +
      '<h4>Frame' + (orderQty > 1 ? ' &times; ' + orderQty : '') + '</h4>' +
      '<div class="lens-review-line">' +
        '<span>' + escapeHtml(productData.title) + '</span>' +
        '<span>$' + productData.price.toFixed(2) + '</span>' +
      '</div>' +
      '</div>';

    // Prescription (if applicable)
    if (selections.prescription && selections.prescriptionType &&
        (selections.prescriptionType.requires_prescription || selections.readingSubType === 'readers')) {
      var rx = selections.prescription;

      if (selections.readingSubType === 'readers') {
        html += '<div class="lens-review-section">' +
          '<h4>Your Prescription</h4>' +
          '<div class="lens-review-line"><span>Magnification Strength</span><span>+' + selections.readersMagnification.toFixed(2) + '</span></div>' +
          '</div>';
      } else if (_rxInputMode === 'upload' && rx._uploadedFileName) {
        // Upload mode — show file name + PD
        var pdDisplay = '';
        if (rx.od_pd !== undefined) {
          pdDisplay = rx.od_pd + '/' + rx.os_pd;
        } else if (rx.pd !== null && rx.pd !== undefined) {
          pdDisplay = rx.pd.toString();
        }
        html += '<div class="lens-review-section">' +
          '<h4>Your Prescription</h4>' +
          '<div class="lens-review-line"><span>Prescription Image</span><span>' + escapeHtml(rx._uploadedFileName) + '</span></div>' +
          '<div class="lens-review-line"><span>PD</span><span>' + pdDisplay + '</span></div>' +
          '</div>';
      } else {
        html += '<div class="lens-review-section">' +
          '<h4>Your Prescription</h4>' +
          '<table class="lens-review-rx-table"><thead><tr>' +
            '<th></th><th>SPH</th><th>CYL</th><th>AXIS</th>' +
            (needsAdd ? '<th>ADD</th>' : '') +
            '<th>PD</th>' +
          '</tr></thead><tbody>';

        var pdDisplay = '';
        if (rx.od_pd !== undefined) {
          pdDisplay = rx.od_pd + '/' + rx.os_pd;
        } else if (rx.pd !== null && rx.pd !== undefined) {
          pdDisplay = rx.pd.toString();
        }

        html += '<tr><td>OD</td>' +
          '<td>' + formatRxValue(rx.od_sph) + '</td>' +
          '<td>' + formatRxValue(rx.od_cyl) + '</td>' +
          '<td>' + (rx.od_axis !== null && rx.od_axis !== undefined ? rx.od_axis : '-') + '</td>' +
          (needsAdd ? '<td>' + formatRxValue(rx.od_add) + '</td>' : '') +
          '<td rowspan="2">' + pdDisplay + '</td>' +
          '</tr>';
        html += '<tr><td>OS</td>' +
          '<td>' + formatRxValue(rx.os_sph) + '</td>' +
          '<td>' + formatRxValue(rx.os_cyl) + '</td>' +
          '<td>' + (rx.os_axis !== null && rx.os_axis !== undefined ? rx.os_axis : '-') + '</td>' +
          (needsAdd ? '<td>' + formatRxValue(rx.os_add) + '</td>' : '') +
          '</tr>';
        html += '</tbody></table></div>';
      }
    }

    // Lens details
    html += '<div class="lens-review-section"><h4>Lens Details</h4>';

    var typeName = selections.prescriptionType.name;
    if (selections.readingSubType === 'readers') {
      typeName = 'Readers';
    } else if (selections.readingSubType === 'prescription-reading') {
      typeName = 'Prescription Reading';
    } else if (selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType) {
      var subOpt = config.lens_configurator.distance_and_reading_sub_options.find(function (s) { return s.id === selections.distanceAndReadingSubType; });
      typeName = subOpt ? subOpt.name : typeName;
    }

    var prescriptionPrice = 0;
    if (selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType) {
      var subOpt = config.lens_configurator.distance_and_reading_sub_options.find(function (s) { return s.id === selections.distanceAndReadingSubType; });
      if (subOpt) {
        prescriptionPrice = productData.isSunglasses ? subOpt.sunglasses_price : subOpt.price;
      }
    } else {
      prescriptionPrice = productData.isSunglasses && selections.prescriptionType.sunglasses_price !== undefined
        ? selections.prescriptionType.sunglasses_price
        : selections.prescriptionType.price_upcharge;
    }

    html += '<div class="lens-review-line">' +
      '<span>Prescription Type: ' + escapeHtml(typeName) + '</span>' +
      '<span>' + (prescriptionPrice > 0 ? '+$' + prescriptionPrice.toFixed(2) : 'Free') + '</span>' +
      '</div>';

    var treatmentName = selections.lensTreatment.name;
    if (selections.lensTreatmentColor) {
      treatmentName += ' (' + capitalize(selections.lensTreatmentColor) + ')';
    }
    html += '<div class="lens-review-line">' +
      '<span>Treatment: ' + escapeHtml(treatmentName) + '</span>' +
      '<span>' + (selections.lensTreatment.price > 0 ? '+$' + selections.lensTreatment.price.toFixed(2) : 'Free') + '</span>' +
      '</div>';

    if (selections.lensIndex) {
      html += '<div class="lens-review-line">' +
        '<span>Thickness: ' + escapeHtml(selections.lensIndex.name) + '</span>' +
        '<span>' + (selections.lensIndex.price > 0 ? '+$' + selections.lensIndex.price.toFixed(2) : 'Free') + '</span>' +
        '</div>';
    }

    html += '</div>';

    // Totals
    html += '<div class="lens-review-section">' +
      '<div class="lens-review-line">' +
        '<span>Lens Service Subtotal' + (orderQty > 1 ? ' (&times;' + orderQty + ')' : '') + '</span>' +
        '<span>$' + (lensServicePrice * orderQty).toFixed(2) + '</span>' +
      '</div>' +
      '<div class="lens-review-line">' +
        '<span>Frame Price' + (orderQty > 1 ? ' (&times;' + orderQty + ')' : '') + '</span>' +
        '<span>$' + (productData.price * orderQty).toFixed(2) + '</span>' +
      '</div>' +
      '<div class="lens-review-total">' +
        '<span>Total</span>' +
        '<span>$' + totalPrice.toFixed(2) + '</span>' +
      '</div>' +
      '</div>';

    html += '</div>';
    stepContent.innerHTML = html;
  }

  // ─── Add to Cart ────────────────────────────────────────────────
  var LENS_SERVICE_PRODUCT_ID = '7922658476075';

  // ─── Prescription Image Upload (Shopify CDN via proxy) ──────────
  // Proxy URL injected by Liquid: window.__UPLOAD_PROXY_URL
  // Falls back to localhost for local dev
  var UPLOAD_PROXY_URL = window.__UPLOAD_PROXY_URL || 'http://localhost:3001/upload';

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        // result is "data:image/...;base64,XXXX"
        var base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function isPermanentCdnUrl(url) {
    return !!url &&
      url.indexOf('https://cdn.shopify.com/') === 0 &&
      url.indexOf('shopify-staged-uploads') === -1;
  }

  async function uploadPrescriptionImage(base64Data, filename, mimeType) {
    if (!base64Data) return { url: null, fileId: null, filename: null, permanent: false, error: 'No base64 data' };
    var payload = {
      image: base64Data,
      filename: filename || 'prescription.png',
      mimeType: mimeType || 'image/jpeg',
    };
    var lastError = 'Unknown error';
    var lastTemporary = null;

    for (var attempt = 1; attempt <= 3; attempt++) {
      try {
        console.log('[Lens Config] Uploading prescription image (attempt ' + attempt + ')...');
        var resp = await fetch(UPLOAD_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify(payload),
        });
        console.log('[Lens Config] Proxy response status:', resp.status);

        if (resp.status === 502 || resp.status === 503 || resp.status === 504) {
          lastError = 'HTTP ' + resp.status + ' (permanent URL not ready)';
          console.warn('[Lens Config] ' + lastError + ', retrying...');
          await new Promise(function (r) { setTimeout(r, 2500 * attempt); });
          continue;
        }

        if (!resp.ok) {
          var errText = await resp.text();
          lastError = 'HTTP ' + resp.status + ': ' + errText.substring(0, 200);
          console.error('[Lens Config] Proxy upload failed:', lastError);
          // Keep going — a previous attempt may still have a temporary URL
          if (lastTemporary) break;
          continue;
        }

        var data = await resp.json();
        console.log('[Lens Config] Proxy response:', JSON.stringify(data));
        if (!data || !data.url) {
          lastError = 'No URL in response';
          continue;
        }

        // Permanent CDN URL is ideal
        if (isPermanentCdnUrl(data.url)) {
          console.log('[Lens Config] Permanent image URL:', data.url);
          return {
            url: data.url,
            fileId: data.fileId || null,
            filename: data.filename || filename,
            permanent: true,
            error: null,
          };
        }

        // Temporary staged URL is acceptable as last resort — better than no link.
        // Keep metadata so the permanent copy can be recovered later by filename/fileId.
        if (data.url.indexOf('shopify-staged-uploads') !== -1) {
          lastTemporary = {
            url: data.url,
            fileId: data.fileId || null,
            filename: data.filename || filename,
            permanent: false,
            error: null,
          };
          console.warn('[Lens Config] Got temporary staged URL (expires ~1 day); will prefer permanent if retry succeeds');
          await new Promise(function (r) { setTimeout(r, 2500 * attempt); });
          continue;
        }

        lastError = 'Unrecognized URL in response';
      } catch (e) {
        lastError = e.message;
        console.error('[Lens Config] Image upload error:', lastError);
        await new Promise(function (r) { setTimeout(r, 1500 * attempt); });
      }
    }

    if (lastTemporary) {
      console.warn('[Lens Config] Using temporary URL fallback:', lastTemporary.url);
      return lastTemporary;
    }
    return { url: null, fileId: null, filename: filename || null, permanent: false, error: lastError };
  }

  function getSelectedQuantity() {
    var qtyInput =
      document.querySelector('[data-quantity-value]') ||
      document.querySelector('input[name="quantity"]:not([type="hidden"])') ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    var qty = parseInt(qtyInput && qtyInput.value, 10);
    return (!qty || isNaN(qty) || qty < 1) ? 1 : qty;
  }

  async function addToCart() {
    console.log('[Lens Config] addToCart called, mode:', _rxInputMode);
    btnNext.classList.add('is-loading');
    btnNext.innerHTML = '<span class="lens-loading-spinner"></span> Adding...';

    try {
      var frameVariantId = parseInt(productData.variantId);
      if (!frameVariantId || isNaN(frameVariantId)) {
        throw new Error('Invalid frame variant ID. Please select a frame color first.');
      }

      // Quantity must match the product form selector so lens service is billed per pair
      var orderQty = getSelectedQuantity();
      console.log('[Lens Config] Order quantity:', orderQty);

      // Step 0: Upload prescription image if present
      var uploadedImageUrl = null;
      if (_rxInputMode === 'upload' && selections.prescription && selections.prescription._uploadedBase64) {
        btnNext.innerHTML = '<span class="lens-loading-spinner"></span> Uploading prescription...';
        console.log('[Lens Config] Calling uploadPrescriptionImage...');
        var uploadResult = await uploadPrescriptionImage(
          selections.prescription._uploadedBase64,
          selections.prescription._uploadedFileName,
          selections.prescription._uploadedMimeType
        );
        uploadedImageUrl = uploadResult.url;
        selections.prescription._uploadedFileId = uploadResult.fileId || null;
        selections.prescription._uploadedShopifyName = uploadResult.filename || selections.prescription._uploadedFileName;
        selections.prescription._uploadedPermanent = !!uploadResult.permanent;
        console.log('[Lens Config] Upload result:', {
          url: uploadedImageUrl,
          permanent: uploadResult.permanent,
          fileId: uploadResult.fileId,
          filename: uploadResult.filename,
          error: uploadResult.error,
        });
        if (!uploadedImageUrl) {
          console.warn('[Lens Config] Image upload failed — proceeding with filename only:', uploadResult.error);
        }
      }

      // Step 1: Remove only the Lens Service item for THIS frame (preserves other frames' lens services)
      btnNext.innerHTML = '<span class="lens-loading-spinner"></span> Adding...';
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      var cart = await cartRes.json();
      var currentFrameVariantId = productData.variantId ? productData.variantId.toString() : '';
      var lensServiceItems = cart.items.filter(function (item) {
        if (!item.product_id || item.product_id.toString() !== LENS_SERVICE_PRODUCT_ID) return false;
        // Match by _frame_variant_id property — only remove the lens service for the current frame
        if (item.properties && item.properties._frame_variant_id) {
          return item.properties._frame_variant_id.toString() === currentFrameVariantId;
        }
        // Fallback: remove if no frame variant info (legacy items)
        return true;
      });
      for (var i = 0; i < lensServiceItems.length; i++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: lensServiceItems[i].key, quantity: 0 }),
        });
      }
      console.log('[Lens Config] Removed', lensServiceItems.length, 'lens service item(s) for frame variant', currentFrameVariantId);

      // Step 2: Build items to add
      var lensVariantId = findLensServiceVariantId();
      var items = [];

      if (lensVariantId) {
        items.push({
          id: frameVariantId,
          quantity: orderQty,
          properties: {
            '_lens_service': 'Included',
          },
        });
        items.push({
          id: lensVariantId,
          quantity: orderQty,
          properties: buildLensProperties(uploadedImageUrl),
        });
      } else {
        // No lens service variant configured — add frame only
        items.push({
          id: frameVariantId,
          quantity: orderQty,
          properties: buildLensProperties(uploadedImageUrl),
        });
      }

      console.log('Cart add request:', JSON.stringify({ items }, null, 2));

      var response = await fetch(CART_ADD_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: items }),
      });

      console.log('Cart add response status:', response.status);
      var responseText = await response.text();
      console.log('Cart add response:', responseText.substring(0, 500));

      if (!response.ok) {
        var errMsg = 'Failed to add to cart (HTTP ' + response.status + ')';
        try {
          var err = JSON.parse(responseText);
          errMsg = err.description || err.message || errMsg;
        } catch (e) {
          if (responseText && responseText.length < 500) errMsg = responseText;
        }
        throw new Error(errMsg);
      }

      close();
      // Start background upgrade of temporary Rx image links (does not block cart)
      scheduleRxLinkUpgrade(800);
      window.location.href = CART_URL;
    } catch (e) {
      alert('Error: ' + e.message);
    } finally {
      btnNext.classList.remove('is-loading');
      btnNext.innerHTML = 'ADD TO CART';
    }
  }

  function findLensServiceVariantId() {
    var variants = config.lens_configurator.lens_service_variants;
    if (!variants || Object.keys(variants).length === 0) {
      console.warn('No lens service variants configured. Using fallback.');
      return null;
    }

    var key = buildVariantKey();
    return variants[key] || null;
  }

  function buildVariantKey() {
    var parts = [];
    if (selections.prescriptionType) {
      parts.push(selections.prescriptionType.id);
      if (selections.prescriptionType.id === 'distance_and_reading' && selections.distanceAndReadingSubType) {
        parts.push(selections.distanceAndReadingSubType);
      }
    }
    if (selections.lensTreatment) {
      parts.push(selections.lensTreatment.id);
    }
    if (selections.lensIndex) {
      parts.push(selections.lensIndex.id);
    } else if (selections.prescriptionType && selections.prescriptionType.id === 'non-prescription') {
      // Non-prescription skips lensIndex step — default to 1.56 standard
      parts.push('1.56');
    }
    return parts.join('_');
  }

  function buildLensProperties(imageUrl) {
    var props = {};
    var rx = selections.prescription;

    var typeName = selections.prescriptionType ? selections.prescriptionType.name : '';
    if (selections.readingSubType === 'readers') {
      typeName = 'Readers';
    } else if (selections.readingSubType === 'prescription-reading') {
      typeName = 'Prescription Reading';
    } else if (selections.prescriptionType && selections.prescriptionType.id === 'distance_and_reading') {
      var subOpt = config.lens_configurator.distance_and_reading_sub_options.find(function (s) { return s.id === selections.distanceAndReadingSubType; });
      typeName = subOpt ? subOpt.name : 'Distance & Reading';
    }
    props['_prescription_type'] = typeName;
    props['_lens_treatment'] = selections.lensTreatment ? selections.lensTreatment.name : '';
    if (selections.lensTreatmentColor) {
      props['_treatment_color'] = capitalize(selections.lensTreatmentColor);
    }
    if (selections.lensIndex) {
      props['_lens_index'] = selections.lensIndex.name;
    }

    if (rx && selections.readingSubType === 'readers') {
      props['_readers_magnification'] = '+' + selections.readersMagnification.toFixed(2);
    } else if (_rxInputMode === 'upload' && rx && rx._uploadedFileName) {
      // Prefer permanent CDN URL; fall back to temporary URL; else filename only.
      props['_prescription_image'] = imageUrl || rx._uploadedFileName;
      if (imageUrl) {
        props['Prescription Image'] = imageUrl;
      }
      // Recovery metadata — lets us upgrade expired staged URLs later
      if (rx._uploadedPermanent === false && imageUrl && imageUrl.indexOf('shopify-staged-uploads') !== -1) {
        props['_rx_link_type'] = 'temporary';
      } else if (rx._uploadedPermanent) {
        props['_rx_link_type'] = 'permanent';
      }
      if (rx._uploadedShopifyName) {
        props['_rx_file'] = rx._uploadedShopifyName;
      }
      if (rx._uploadedFileId) {
        props['_rx_file_id'] = rx._uploadedFileId;
      }
      if (rx.od_pd !== undefined) {
        props['_pd_od'] = rx.od_pd.toString();
        props['_pd_os'] = rx.os_pd.toString();
      } else if (rx.pd !== null && rx.pd !== undefined) {
        props['_pd'] = rx.pd.toString();
      }
      if (rx.has_prism) {
        props['_has_prism'] = 'Yes';
        ['od', 'os'].forEach(function (eye) {
          if (rx[eye + '_prism_amount']) props['_' + eye + '_prism'] = rx[eye + '_prism_amount'] + ' ' + (rx[eye + '_prism_direction'] || '');
        });
      }
    } else if (rx && selections.prescriptionType && selections.prescriptionType.requires_prescription) {
      if (rx.od_sph !== null && rx.od_sph !== undefined) props['_od_sph'] = formatRxValue(rx.od_sph);
      if (rx.od_cyl !== null && rx.od_cyl !== undefined) props['_od_cyl'] = formatRxValue(rx.od_cyl);
      if (rx.od_axis !== null && rx.od_axis !== undefined) props['_od_axis'] = rx.od_axis.toString();
      if (rx.os_sph !== null && rx.os_sph !== undefined) props['_os_sph'] = formatRxValue(rx.os_sph);
      if (rx.os_cyl !== null && rx.os_cyl !== undefined) props['_os_cyl'] = formatRxValue(rx.os_cyl);
      if (rx.os_axis !== null && rx.os_axis !== undefined) props['_os_axis'] = rx.os_axis.toString();
      if (rx.od_add !== null && rx.od_add !== undefined) props['_od_add'] = formatRxValue(rx.od_add);
      if (rx.os_add !== null && rx.os_add !== undefined) props['_os_add'] = formatRxValue(rx.os_add);
      if (rx.od_pd !== undefined) {
        props['_pd_od'] = rx.od_pd.toString();
        props['_pd_os'] = rx.os_pd.toString();
      } else if (rx.pd !== null && rx.pd !== undefined) {
        props['_pd'] = rx.pd.toString();
      }
    }

    props['_frame_product'] = productData.title;
    props['_frame_variant_id'] = productData.variantId;

    return props;
  }

  // ─── Helpers ────────────────────────────────────────────────────
  function formatNumber(val, step) {
    if (step >= 1) return Math.round(val).toString();
    var decimals = step.toString().split('.')[1] || '';
    return val.toFixed(decimals.length);
  }

  function formatRxValue(val) {
    if (val === null || val === undefined) return '-';
    var prefix = val > 0 ? '+' : '';
    return prefix + val.toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function getColorHex(color) {
    var map = {
      black: '#333333',
      gray: '#888888',
      brown: '#8B4513',
      pink: '#FFB6C1',
      yellow: '#FFD700',
      green: '#228B22',
    };
    return map[color] || '#ccc';
  }

  function getTypeIcon(id) {
    var icons = {
      distance: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/></svg>',
      distance_and_reading: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12h20M12 2v20"/><circle cx="12" cy="12" r="10"/></svg>',
      progressive: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12h20M12 2v20"/><circle cx="12" cy="12" r="10"/></svg>',
      reading: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>',
      'non-prescription': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>',
    };
    return icons[id] || icons.distance;
  }

  function getTreatmentIcon(id) {
    var icons = {
      clear: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/></svg>',
      'blue-light': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
      photochromic: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/></svg>',
      driving: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
      tinted: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/></svg>',
      polarized: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707"/><circle cx="12" cy="12" r="4"/></svg>',
      'default-sunglasses': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/></svg>',
      'mirror-coating': '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707"/><circle cx="12" cy="12" r="4"/></svg>',
    };
    return icons[id] || icons.clear;
  }

  function getIndexIcon(id) {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v12M6 12h12"/></svg>';
  }

  // ─── Bootstrap ──────────────────────────────────────────────────
  function waitForButtons() {
    var btns = document.querySelectorAll('[data-action="open-lens-configurator"]');
    if (btns.length > 0) {
      init();
    } else {
      console.log('[Lens Config] Buttons not found yet, retrying in 500ms...');
      setTimeout(waitForButtons, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForButtons);
  } else {
    waitForButtons();
  }

  // ─── Cart page: replace Prescription Image URL with thumbnail ──────
  function enhanceCartProperties() {
    // Find all text nodes containing a prescription image URL
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) {
      var text = walker.currentNode.textContent.trim();
      if (text.indexOf('https://shopify-staged-uploads.storage.googleapis.com') === 0 ||
          text.indexOf('https://cdn.shopify.com') === 0) {
        // Check if the previous sibling text contains "Prescription Image"
        var prev = walker.currentNode.parentElement;
        if (prev) {
          var container = prev.closest('li, div, span');
          if (container && container.textContent.indexOf('Prescription Image') !== -1) {
            nodes.push({ textNode: walker.currentNode, url: text, parent: prev });
          }
        }
      }
    }
    nodes.forEach(function(n) {
      // Skip if already enhanced
      if (n.parent.querySelector('img')) return;
      // Replace text with thumbnail + link
      var link = document.createElement('a');
      link.href = n.url;
      link.target = '_blank';
      link.textContent = 'View Prescription Image';
      link.style.cssText = 'color:#B37A4C;text-decoration:underline;display:block;margin-top:4px;';
      var img = document.createElement('img');
      img.src = n.url;
      img.alt = 'Prescription';
      img.style.cssText = 'max-width:120px;margin-top:4px;border-radius:4px;';
      n.parent.textContent = '';
      n.parent.appendChild(link);
      n.parent.appendChild(img);
    });
  }

  // ─── Background upgrade: temporary staged URL → permanent CDN URL ──────────
  // Never blocks add-to-cart. Polls after cart add / on cart page and rewrites
  // line-item properties before checkout captures them into the order.
  var _rxUpgradeTimer = null;
  var _rxUpgradeRunning = false;

  function isStagedUrl(url) {
    return !!url && String(url).indexOf('shopify-staged-uploads') !== -1;
  }

  function mergePrescriptionProps(existing, permanentUrl, meta) {
    var props = {};
    var keys = Object.keys(existing || {});
    for (var i = 0; i < keys.length; i++) {
      props[keys[i]] = existing[keys[i]];
    }
    props['_prescription_image'] = permanentUrl;
    props['Prescription Image'] = permanentUrl;
    props['_rx_link_type'] = 'permanent';
    if (meta && meta.filename) props['_rx_file'] = meta.filename;
    if (meta && meta.fileId) props['_rx_file_id'] = meta.fileId;
    return props;
  }

  async function resolvePermanentUrlOnProxy(fileId, filename) {
    var qs = [];
    if (fileId) qs.push('fileId=' + encodeURIComponent(fileId));
    if (filename) qs.push('filename=' + encodeURIComponent(filename));
    if (!qs.length) return null;
    try {
      var base = (typeof UPLOAD_PROXY_URL === 'string')
        ? UPLOAD_PROXY_URL.replace(/\/upload\/?$/, '')
        : '';
      if (!base) base = 'https://rx-upload-proxy.onrender.com';
      var resp = await fetch(base + '/resolve-url?' + qs.join('&'), {
        credentials: 'include',
      });
      if (!resp.ok) return null;
      var data = await resp.json();
      if (data && data.permanent && data.url && isPermanentCdnUrl(data.url)) {
        return data.url;
      }
    } catch (e) {
      console.warn('[Lens Config] resolve-url failed:', e.message);
    }
    return null;
  }

  async function upgradeCartRxLinks() {
    if (_rxUpgradeRunning) return;
    _rxUpgradeRunning = true;
    try {
      var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) return;
      var cart = await cartRes.json();
      if (!cart || !cart.items || !cart.items.length) return;

      var pending = cart.items.filter(function (item) {
        var p = item.properties || {};
        var img = p['_prescription_image'] || p['Prescription Image'] || '';
        var isTemp = p['_rx_link_type'] === 'temporary' || isStagedUrl(img);
        // Only touch lens-service style lines that actually carry Rx image links
        return isTemp && (p['_rx_file'] || p['_rx_file_id'] || isStagedUrl(img) || p['_prescription_image']);
      });

      if (!pending.length) {
        console.log('[Lens Config] No temporary Rx links to upgrade');
        return;
      }

      console.log('[Lens Config] Upgrading', pending.length, 'temporary Rx link(s)...');

      for (var i = 0; i < pending.length; i++) {
        var item = pending[i];
        var p = item.properties || {};
        var fileId = p['_rx_file_id'] || null;
        var filename = p['_rx_file'] || null;
        if (!filename) {
          var img = p['_prescription_image'] || p['Prescription Image'] || '';
          if (img) {
            var parts = img.split('/');
            filename = decodeURIComponent(parts[parts.length - 1] || '') || null;
          }
        }

        var permanentUrl = await resolvePermanentUrlOnProxy(fileId, filename);
        if (!permanentUrl) {
          console.log('[Lens Config] Permanent URL still pending for', filename || fileId);
          continue;
        }

        var newProps = mergePrescriptionProps(p, permanentUrl, { fileId: fileId, filename: filename });
        var changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: newProps,
          }),
        });
        if (changeRes.ok) {
          console.log('[Lens Config] Upgraded Rx link on cart item', item.key, '→', permanentUrl);
        } else {
          console.warn('[Lens Config] cart/change failed:', changeRes.status);
        }
      }
    } catch (e) {
      console.warn('[Lens Config] upgradeCartRxLinks error:', e.message);
    } finally {
      _rxUpgradeRunning = false;
    }
  }

  function scheduleRxLinkUpgrade(initialDelayMs) {
    if (_rxUpgradeTimer) clearTimeout(_rxUpgradeTimer);
    var attempts = 0;
    var maxAttempts = 12; // ~2–3 minutes of gentle polling

    function tick() {
      attempts++;
      upgradeCartRxLinks().then(function () {
        if (attempts >= maxAttempts) return;
        // Keep polling while temporary links remain; stop early once all permanent
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var stillTemp = (cart.items || []).some(function (item) {
              var p = item.properties || {};
              var img = p['_prescription_image'] || p['Prescription Image'] || '';
              return p['_rx_link_type'] === 'temporary' || isStagedUrl(img);
            });
            if (stillTemp) {
              _rxUpgradeTimer = setTimeout(tick, 10000);
            } else {
              console.log('[Lens Config] All Rx links are permanent; stop polling');
            }
          })
          .catch(function () {
            _rxUpgradeTimer = setTimeout(tick, 15000);
          });
      });
    }

    _rxUpgradeTimer = setTimeout(tick, initialDelayMs || 1000);
  }

  // Global: upgrade temporary Rx links whenever cart still has them
  // (covers mini-cart checkout and direct /checkout without visiting /cart)
  (function bootGlobalRxUpgrade() {
    function startIfTempLinksExist() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasTemp = (cart.items || []).some(function (item) {
            var p = item.properties || {};
            var img = p['_prescription_image'] || p['Prescription Image'] || '';
            return p['_rx_link_type'] === 'temporary' || isStagedUrl(img);
          });
          if (hasTemp) {
            console.log('[Lens Config] Cart has temporary Rx links; starting background upgrade');
            scheduleRxLinkUpgrade(500);
          }
        })
        .catch(function () {});
    }

    // After any add-to-cart, re-check
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest && e.target.closest(
        'form[action*="/cart/add"] [type="submit"], [data-action="open-lens-configurator"], .product-form__buttons button'
      );
      if (addBtn) setTimeout(startIfTempLinksExist, 2500);
    });

    // Global checkout click: try one fast upgrade pass
    document.addEventListener('click', function (e) {
      var checkoutBtn = e.target.closest && e.target.closest(
        'form[action="/checkout"] button, form[action="/checkout"] input[type="submit"], ' +
        'a[href*="/checkout"], .cart__checkout, [name="checkout"], #checkout, .checkout-btn'
      );
      if (!checkoutBtn) return;
      upgradeCartRxLinks();
    }, true);

    // On any page load, quietly upgrade if needed
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(startIfTempLinksExist, 1500);
      });
    } else {
      setTimeout(startIfTempLinksExist, 1500);
    }
  })();

  // Run on cart page
  if (window.location.pathname === '/cart') {
    function bootCartEnhancements() {
      setTimeout(enhanceCartProperties, 1000);
      setTimeout(enhanceCartProperties, 3000);
      // Background upgrade temporary → permanent (does not block checkout UI)
      scheduleRxLinkUpgrade(600);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootCartEnhancements);
    } else {
      bootCartEnhancements();
    }
    // Also observe for cart updates (AJAX cart)
    var observer = new MutationObserver(function() {
      setTimeout(enhanceCartProperties, 500);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Last-chance upgrade when customer heads to checkout
    document.addEventListener('click', function (e) {
      var checkoutBtn = e.target.closest && e.target.closest(
        'form[action="/checkout"] button, form[action="/checkout"] input[type="submit"], a[href="/checkout"], .cart__checkout, [name="checkout"]'
      );
      if (!checkoutBtn) return;
      // Kick an immediate upgrade pass; cart properties are snapshotted at checkout submit,
      // so a fast pass here can still land permanent URLs before the order is created.
      upgradeCartRxLinks();
    }, true);
  }
})();
